import { createFileRoute } from "@tanstack/react-router";
import { ValuesPage, valuesHead } from "@/features/company-story";

export const Route = createFileRoute("/values")({
    component: ValuesPage,
    head: valuesHead,
});
